import Vue from 'vue';
import WorkContainer from '@/components/global_components/grid/WorkContainer';
import WorkColumn from '@/components/global_components/grid/WorkColumn';
import WorkRow from '@/components/global_components/grid/WorkRow';

Vue.component('WContainer', WorkContainer);
Vue.component('WColumn', WorkColumn);
Vue.component('WRow', WorkRow);
